





































































import Widget from './libs/widget'
import newsletter from '@/components/newsletter.vue'
import southpackage from '@/components/southpackage.vue'
import Vue from 'vue'

export default Vue.extend({
	name: 'myapp',
	components: {newsletter, southpackage},
	data() {
		return {
			showwidget: false,
			showmail: true,
			email: '',
			fullname: '',
			image: '',
			title: '',
			showphone: true,
			phone: '',
			homelink: '',
			fblink: '',
			twitterlink: '',
			agentid: 0,
			concoursimage: '',
			showconcours: false,
			southpackloaded: false,
			southPackagesPortals: document.getElementsByClassName('mvma-southpackage'),
			canshowsearchengine: false
		}
	},

	mounted() {
		this.startapp()
	},

	methods: {
		startapp() {
			this.southPackagesPortals = document.getElementsByClassName('mvma-southpackage')
			// console.log(document.getElementsByClassName('mvma-southpackage'))
			this.southpackloaded = true
			const widget = new Widget()
			const self = this
			widget.getAgentIdent().then((data: any) => {
				if (data) {
					if (widget.getAlias() !== 'W9N' && widget.getAlias() !== 'DES') {
						self.canshowsearchengine = true
					}
					this.$store.state.agentid = widget.getAgentForConcours()
					this.$store.state.agencyalias = widget.getAlias()
					this.$store.state.agentinfos = widget.getAllInfos()
					this.$store.state.mode = widget.getMode()
					self.showwidget = true
					self.fullname = widget.getFullname()
					self.image = widget.getImage()
					self.title = widget.getSubtitle()
					self.showmail = widget.canShowEmail()
					self.email = widget.getEmail()
					self.showphone = widget.canShowPhone()
					self.phone = widget.getPhone()
					self.homelink = widget.getHomelink()
					self.fblink = widget.getFbLink()
					self.twitterlink = widget.getTwitterLink()
					self.agentid = widget.getAgentId()
					self.concoursimage = widget.getConcoursImage()
					// remove comment form
					const commentform = document.querySelector('#comments')
					if (commentform) {
						commentform.remove()
					}
				}
			})
		}
	}
})
